import "./update_profile_page.css";
import React, { useRef } from "react";
import { TabsNavigation, Tab, Breadcrumb, ButtonGroup, Accordion, Icon, Slot, AccordionV2, AccordionItemV2, AccordionItem, Font, Notification } from "pepsico-ds";
import { useState, useEffect } from "react";
import AssociateAndJobInfoEdit from "../../manage_accounts/update_profile/associate_&_jobinfo_edit.jsx";
import PersonalInfo from "./personal_info.jsx";
import { useLocation, useNavigate } from "react-router-dom";
import { useUserProfile } from "../../../common/user_profile_context.jsx";
import ContractorInformationEdit from "./contractor_informations.jsx";
import ErrorFailOverHandler from "../../../common/error_fail_over_handler.jsx";
import { useTranslation } from "react-i18next";
import { useLoading } from "../../../loader.jsx";
import updateProfileService from "./update_profile.service.jsx";
import { useSelector } from "react-redux";

const UpdateProfile = () => {
  const { t } = useTranslation();
  const { state } = useLocation();
  const navigate = useNavigate();
  const userDataFromStore = useSelector((state)=> state.userDetails)
  let { userProfile, loading } = useUserProfile();
  const { isEmailValidate } = state || { isEmailValidate: false };
  const [selectedTab, setSelectedTab] = useState(0);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [isContractorProfile, setIsContractorProfile] = useState(false);
  const [selectedButton, setSelectedButton] = useState(0);
  const [ShowAssociateAndJobInfoEdit, setShowAssociateAndJobInfoEdit] = useState(false);
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  const [userDetailResp, setUserDetailResp] = useState({});
  const [showErrorPage, setShowErrorPage] = useState(false);
  const [showPreferredLanguageError, setShowPreferredLanguageError] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [formValues, setFormValues] = useState({
      gpId: "",
      firstName: "",
      pronouns: "",
      lastName: "",
      displayedFirstName: "",
      displayedLastName: "",
      preferredName: "",
      email: "",
      mobile: "",
      phone: "",
      associateType: "",
      company: "",
      division: "",
      subdivision: "",
      location: "",
      department: "",
      extension: "",
      registered: "",
      delegatedSecurity: "",
      preferredLanguage: "",
      alternateEmail: "",
      reportingManager: "",
      jobFunction: "",
      jobTitle: "",
      security: [],
      officePhone: "",
      organization: "",
      country: "",
      middleName: "",
      pgcsAccess: ""
  });

  const [respFormValues, setRespFormValues] = useState({
      gpId: "",
      firstName: "",
      pronouns: "",
      lastName: "",
      displayedFirstName: "",
      displayedLastName: "",
      preferredName: "",
      email: "",
      mobile: "",
      phone: "",
      associateType: "",
      company: "",
      division: "",
      subdivision: "",
      location: "",
      department: "",
      extension: "",
      registered: "",
      delegatedSecurity: "",
      preferredLanguage: "",
      alternateEmail: "",
      reportingManager: "",
      jobFunction: "",
      jobTitle: "",
      security: [],
      officePhone: "",
      organization: "",
      country: "",
      middleName: "",
      pgcsAccess: ""
  });

  const [formChanged, setFormChanged] = useState(false);
  const fieldsChangedRef = useRef([]);

  const resetField = () => {
    setFormValues(respFormValues);
  }

  const updateRespFormValuesAfterSuccess = () =>{
    setRespFormValues(formValues)
  }

  useEffect(() => {
    if (loading || !userProfile) return;
    // userProfile.associateType = "Contractor";
  }, [loading, userProfile, state]);

  const countriesOptions = [
    { id: "Afghanistan", displayText: "Afghanistan" },
    { id: "Albania", displayText: "Albania" },
    { id: "Algeria", displayText: "Algeria" },
    { id: "Andorra", displayText: "Andorra" },
    { id: "Angola", displayText: "Angola" },
    { id: "Argentina", displayText: "Argentina" },
    { id: "Armenia", displayText: "Armenia" },
    { id: "Australia", displayText: "Australia" },
    { id: "Austria", displayText: "Austria" },
    { id: "Azerbaijan", displayText: "Azerbaijan" },
    { id: "Bahamas", displayText: "Bahamas" },
    { id: "Bahrain", displayText: "Bahrain" },
    { id: "Bangladesh", displayText: "Bangladesh" },
    { id: "Belgium", displayText: "Belgium" },
    { id: "Bhutan", displayText: "Bhutan" },
    { id: "Bolivia", displayText: "Bolivia" },
    { id: "Bosnia and Herzegovina", displayText: "Bosnia and Herzegovina" },
    { id: "Botswana", displayText: "Botswana" },
    { id: "Brazil", displayText: "Brazil" },
    { id: "Bulgaria", displayText: "Bulgaria" },
    { id: "Cambodia", displayText: "Cambodia" },
    { id: "Cameroon", displayText: "Cameroon" },
    { id: "Canada", displayText: "Canada" },
    { id: "Chile", displayText: "Chile" },
    { id: "China", displayText: "China" },
    { id: "Colombia", displayText: "Colombia" },
    { id: "Costa Rica", displayText: "Costa Rica" },
    { id: "Croatia", displayText: "Croatia" },
    { id: "Cuba", displayText: "Cuba" },
    { id: "Cyprus", displayText: "Cyprus" },
    { id: "Czech Republic", displayText: "Czech Republic" },
    { id: "Denmark", displayText: "Denmark" },
    { id: "Dominican Republic", displayText: "Dominican Republic" },
    { id: "Ecuador", displayText: "Ecuador" },
    { id: "Egypt", displayText: "Egypt" },
    { id: "El Salvador", displayText: "El Salvador" },
    { id: "Estonia", displayText: "Estonia" },
    { id: "Ethiopia", displayText: "Ethiopia" },
    { id: "Finland", displayText: "Finland" },
    { id: "France", displayText: "France" },
    { id: "Georgia", displayText: "Georgia" },
    { id: "Germany", displayText: "Germany" },
    { id: "Greece", displayText: "Greece" },
    { id: "Guatemala", displayText: "Guatemala" },
    { id: "Honduras", displayText: "Honduras" },
    { id: "Hungary", displayText: "Hungary" },
    { id: "Iceland", displayText: "Iceland" },
    { id: "India", displayText: "India" },
    { id: "Indonesia", displayText: "Indonesia" },
    { id: "Iran", displayText: "Iran" },
    { id: "Iraq", displayText: "Iraq" },
    { id: "Ireland", displayText: "Ireland" },
    { id: "Israel", displayText: "Israel" },
    { id: "Italy", displayText: "Italy" },
    { id: "Jamaica", displayText: "Jamaica" },
    { id: "Japan", displayText: "Japan" },
    { id: "Jordan", displayText: "Jordan" },
    { id: "Kazakhstan", displayText: "Kazakhstan" },
    { id: "Kenya", displayText: "Kenya" },
    { id: "Kuwait", displayText: "Kuwait" },
    { id: "Latvia", displayText: "Latvia" },
    { id: "Lebanon", displayText: "Lebanon" },
    { id: "Lithuania", displayText: "Lithuania" },
    { id: "Luxembourg", displayText: "Luxembourg" },
    { id: "Malaysia", displayText: "Malaysia" },
    { id: "Maldives", displayText: "Maldives" },
    { id: "Mexico", displayText: "Mexico" },
    { id: "Monaco", displayText: "Monaco" },
    { id: "Mongolia", displayText: "Mongolia" },
    { id: "Morocco", displayText: "Morocco" },
    { id: "Nepal", displayText: "Nepal" },
    { id: "Netherlands", displayText: "Netherlands" },
    { id: "New Zealand", displayText: "New Zealand" },
    { id: "Nigeria", displayText: "Nigeria" },
    { id: "Norway", displayText: "Norway" },
    { id: "Oman", displayText: "Oman" },
    { id: "Pakistan", displayText: "Pakistan" },
    { id: "Panama", displayText: "Panama" },
    { id: "Paraguay", displayText: "Paraguay" },
    { id: "Peru", displayText: "Peru" },
    { id: "Philippines", displayText: "Philippines" },
    { id: "Poland", displayText: "Poland" },
    { id: "Portugal", displayText: "Portugal" },
    { id: "Qatar", displayText: "Qatar" },
    { id: "Romania", displayText: "Romania" },
    { id: "Russia", displayText: "Russia" },
    { id: "Saudi Arabia", displayText: "Saudi Arabia" },
    { id: "Serbia", displayText: "Serbia" },
    { id: "Singapore", displayText: "Singapore" },
    { id: "Slovakia", displayText: "Slovakia" },
    { id: "Slovenia", displayText: "Slovenia" },
    { id: "South Africa", displayText: "South Africa" },
    { id: "South Korea", displayText: "South Korea" },
    { id: "Spain", displayText: "Spain" },
    { id: "Sri Lanka", displayText: "Sri Lanka" },
    { id: "Sweden", displayText: "Sweden" },
    { id: "Switzerland", displayText: "Switzerland" },
    { id: "Syria", displayText: "Syria" },
    { id: "Taiwan", displayText: "Taiwan" },
    { id: "Tanzania", displayText: "Tanzania" },
    { id: "Thailand", displayText: "Thailand" },
    { id: "Tunisia", displayText: "Tunisia" },
    { id: "Turkey", displayText: "Turkey" },
    { id: "Uganda", displayText: "Uganda" },
    { id: "Ukraine", displayText: "Ukraine" },
    { id: "United Arab Emirates", displayText: "United Arab Emirates" },
    { id: "United Kingdom", displayText: "United Kingdom" },
    { id: "United States", displayText: "United States" },
    { id: "Uruguay", displayText: "Uruguay" },
    { id: "Uzbekistan", displayText: "Uzbekistan" },
    { id: "Venezuela", displayText: "Venezuela" },
    { id: "Vietnam", displayText: "Vietnam" },
    { id: "Yemen", displayText: "Yemen" },
    { id: "Zambia", displayText: "Zambia" },
    { id: "Zimbabwe", displayText: "Zimbabwe" }
  ];

  const pronounsOptions = [
    { displayText: "He/Him", id: "1" },
    { displayText: "She/Her", id: "2" },
    { displayText: "They/Them", id: "3" },
    { displayText: "They/He", id: "4" },
    { displayText: "They/She", id: "5" },
    { displayText: "Xe/Xem", id: "6" },
    { displayText: "I Use Another Term", id: "7" },
    { displayText: "I Don't Use Pronouns", id: "8" },
    { displayText: "Prefer Not to Disclose", id: "9" },
  ];

  const PGCSAccessOptions = [
    { displayText: "Yes", id: "yes" },
    { displayText: "No", id: "no" }
  ];

  const preferredLanguageOptions = [
    { displayText: "English", id: "en_US" },
    { displayText: "Español", id: "es_ES" },
    { displayText: "Français", id: "fr_FR" },
    { displayText: "Português", id: "pt_BR" },
    { displayText: "Русском", id: "ru_RU" },
    { displayText: "简体中文", id: "zh_CN" },
    { displayText: "العربية", id: "ar_SA" },
  ];

  const { showLoader:showInfoLoader, hideLoader:hideInfoLoader} = useLoading();
  const [isInfoLoading, setIsInfoLoading] = useState(false);

  const [securityOptions, setSecurityOptions] = useState([]);
  const [userDetails, setUserDetails] = useState(null);
  const [disableSave, setDisableSave] = useState(false);
  const [firstNameError, setFirstNameError] = useState("");
  const [middleNameError, setMiddleNameError] = useState("");
  const [lastNameError, setLastNameError] = useState("");
  const [displayedFirstNameError, setDisplayedFirstNameError] = useState("");
  const [displayedLastNameError, setDisplayedLastNameError] = useState("");

  useState(()=>{
    if(state?.from === 'update-profile'){
      setFormValues(userDataFromStore?.userData)
      setSecurityOptions(userDataFromStore?.securityOptions)
      setUserDetails(userDataFromStore?.userDetails)
      setDisableSave(userDataFromStore?.disableSave)
      setFirstNameError(userDataFromStore?.firstNameError)
      setMiddleNameError(userDataFromStore?.middleNameError)
      setLastNameError(userDataFromStore?.lastNameError)
      setDisplayedFirstNameError(userDataFromStore?.displayedFirstNameError)
      setDisplayedLastNameError(userDataFromStore?.displayedLastNameError)
      fieldsChangedRef.current = userDataFromStore?.fieldsChangedRef
    }
  },[state?.from])

  useEffect(() => {
    if (loading || !userProfile || state?.from === 'update-profile') return;
    showInfoLoader();
    setIsInfoLoading(true);
    const body = state?.userProfileBy === 'Others' ? { gpid: state?.gpId || userProfile?.gpId, manageForOthers: true } : { gpid: state?.gpId || userProfile?.gpId };
    updateProfileService.getUserDetails(body).then((resp) => {
      if(resp?.status === "Failed"){
        onShowErrorPage(true);
        setIsInfoLoading(false);
        hideInfoLoader();
        return;
      }
      const securityOptionsResp = resp.profileDetails?.userAddedYouAsSecAss?.split(',')?.filter(Boolean)?.map((gpid) => ({ displayText: gpid, id: gpid }))
      setSecurityOptions(securityOptionsResp || []);
      setUserDetailResp?.(resp.profileDetails);
      setUserDetails(resp.profileDetails);
      let countryValue = countriesOptions?.filter((c)=> c.id?.toLowerCase?.() == resp.profileDetails?.country?.toLowerCase?.());
      if(!countryValue.length && resp.profileDetails?.country){
        countriesOptions.push([{ id: resp.profileDetails?.country, displayText: resp.profileDetails?.country }])
        countryValue = [{ id: resp.profileDetails?.country, displayText: resp.profileDetails?.country }];
      }

      const respDataObj = {
        gpId: resp.profileDetails?.gpId || "",
        firstName: resp.profileDetails?.firstName || "",
        pronouns: pronounsOptions.filter((pr)=> pr.displayText == resp.profileDetails?.pronouns)  || "",
        pgcsAccess: PGCSAccessOptions.filter((pgcs)=> pgcs.displayText?.toLowerCase?.() == resp.profileDetails?.pgcsAccess?.toLowerCase())  || "",
        lastName: resp.profileDetails?.lastName || "",
        displayedFirstName: resp.profileDetails?.displayedFirstName || "",
        displayedLastName: resp.profileDetails?.displayedLastName || "",
        preferredName: resp.profileDetails?.preferredName || "",
        email: resp.profileDetails?.email || "",
        // mobile: resp.profileDetails.phone || "",
        phone: resp.profileDetails?.phone || "",
        associateType: resp.profileDetails?.associateType || "",
        company: resp.profileDetails?.company || "",
        division: resp.profileDetails?.division || "",
        subdivision: resp.profileDetails?.subDivision || "",
        location: resp.profileDetails?.location || "",
        department: resp.profileDetails?.department || "",
        extension: resp.profileDetails?.ext || "",
        registered: resp.profileDetails?.registered ? "True" : "False" || "",
        delegatedSecurity: resp.profileDetails?.securityAssitant || "",
        preferredLanguage: preferredLanguageOptions.filter((pl) => pl.id == resp.profileDetails?.pepmyidMPreferredLanguage || pl.id?.split("_")?.join("-") == resp.profileDetails?.pepmyidMPreferredLanguage || pl.id?.split("_")?.[0] == resp.profileDetails?.pepmyidMPreferredLanguage) || "",
        reportingManager: state?.reportingManger ? `${state.reportingManger}` : resp.profileDetails?.reportingManager || "",
        jobFunction: resp.profileDetails?.jobFunction || "",
        jobTitle: resp.profileDetails?.jobTitle || "",
        security: securityOptionsResp,
        organization: resp.profileDetails?.organization || "",
        country: countryValue.length > 0 ? countryValue : "",
        middleName: resp.profileDetails?.middleName || "",
        pgtDelegatedManager: state?.pgtDelegatedManager ? `${state.pgtDelegatedManager}` : resp.profileDetails?.pgtDelegatedManager || "",
        category: resp.profileDetails?.category,
        project: resp.profileDetails?.project,
        expirationDate: resp.profileDetails?.revalidationDate
      }

      setFormValues((prev) => ({
        ...prev,
        ...respDataObj
      }));
      setRespFormValues((prev) => ({
        ...prev,
        ...respDataObj
      }));
      onShowErrorPage(false);
      setIsInfoLoading(false);
      hideInfoLoader();
    }, (error) => {
      console.error("Failed to fetch user details:", error);
      onShowErrorPage(true);
      setIsInfoLoading(false);
      hideInfoLoader();
    });
  }, [loading, userProfile]);

  useEffect(() => {
      if (state?.from === 'update-profile') {
          setFormValues({
              ...formValues,
              [state.searchType]: state?.reportingMangerData ? `${state.reportingMangerData.gpid}` : formValues[state.searchType],
          });
      }

      // setReportingManagerData(state?.reportingMangerData ? true : false);
      setIsEditable(state?.from === 'update-profile' ? true : false);
      setFormChanged(state?.from === 'update-profile' ? true : false);
      // if(state?.searchType && fieldsChanged.indexOf(state?.searchType) === -1 && state?.from === 'update-profile') {
      //    setFieldsChanged((prev) => [...prev, state.searchType]);
      // }
      if(state?.searchType && fieldsChangedRef.current?.indexOf(state?.searchType) === -1 && state?.from === 'update-profile'){
          fieldsChangedRef.current = [...fieldsChangedRef.current, state.searchType]
      }
  }, [state?.from, state?.reportingMangerData]);

  useEffect(() => {
    if (isEmailValidate) {
      setSelectedButton(1);
    }
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [isEmailValidate, state]);

  const onClickCancel = () => {
    setShowAssociateAndJobInfoEdit(false)
  }

  const onClickButton = (selectedBtn) => {
    setSelectedButton(selectedBtn)
    if (ShowAssociateAndJobInfoEdit) {
      setShowAssociateAndJobInfoEdit(false);
    }
  }

  const onShowErrorPage = (value) => {
    setShowErrorPage(value);
  }

  const onClickEditMode = () => {
    setShowAssociateAndJobInfoEdit(true);
  };

  const onPersonalInfoValidate = () => {
    setSelectedButton(1);
  }

  return (
    <>
      {showErrorPage ? (
        <ErrorFailOverHandler
          header="No Data found"
          title="Uh oh, we can’t seem to find the page you’re looking for."
          supportMessage="Try going back or contact"
          supportLabel="Support"
          supportLink="mailto:DL-IAMCentralDevelopment@ips.com?subject=Support Request&body=Hello Team,"
          alternateMessage="You can also complete tasks in myidM"
          alternateLabel="Go to myIDM"
          alternateLink="https://myidm.mypepsico.com/iam/im/pepsico/ca12/index.jsp?task.tag=PendingApprovals"
          image="src/assets/error.png" />
      ) : (
    <div id="update_profile_page">
      {isMobile ? (
        <div className="my-account-btn" onClick={() => !isEmailValidate && window.history.back()}><Icon
          alt="alt value"
          icon="arrow_back"
          size="medium"
          style={{ marginRight: '8px' }}          
        />{isEmailValidate ? 'Validate Phone Using One-Time Passcode' : 'My account'}</div>
      ) : <Breadcrumb
          homeIcon={{
            icon: "home",
            onClick:()=>{
              navigate("/home")
            }
          }}
          breadcrumbs={[
              {
                  label: 'Home'
              },
              {
                  label: <div onClick={()=>{
                    navigate("/myidmPortal")
                  }}>myidM</div>
              },
              {
                  label: isEmailValidate ? 'Validate Phone Using One-Time Passcode' : state?.userProfileBy === 'Others' ? t("myIdmPortal.update_profile_for_others") : userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile') ? t("updateProfile.updateProfile") : t("homePage.view_profile"),
              }
          ]}
          className=""
          style={{}}
      />}
      <div className={isMobile ? "mobile-profile-header" : "profile-header"}>
        <span className={isMobile ? "h4" : "h1 page-title mb-10"} style={{ fontSize: !isMobile ? '18px' : '', fontWeight: !isMobile ? 'bold' : '' }}>
          {isEmailValidate ? 'Validate Phone Using One-Time Passcode' : state?.userProfileBy === 'Others' ? t("myIdmPortal.update_profile_for_others") : userProfile?.pepappiamcentralfeatures?.includes('UpdateProfile') ? t("updateProfile.updateProfile") : t("homePage.view_profile")}
        </span>
        {/* {userProfile.associateType?.toLowerCase()?.includes("employee") &&
          <ButtonGroup
            className={`custom-button-group selected-${selectedButton}`}
            items={[
              {
                icon: 'person',
                label: 'Associate & Job info',
                onClick: () => onClickButton(0)
              },
              {
                icon: 'smartphone',
                label: 'Personal Info',
                onClick: () => onClickButton(1)
              }
            ]}
            menuPosition="bottom-right"
            size="medium"
            style={{ marginLeft: !isMobile ? "auto" : "" }}
          />
        } */}
      </div>
      {
        showPreferredLanguageError ?
        <Notification
          // primaryActionLabel={t("homePage.change_password_button")}
          // primaryActionOnClick={changePassword}
          secondaryActionLabel={t("homePage.close_button")}
          secondaryActionOnClick={() => setShowPreferredLanguageError(false)}
          // text={
            
          // }
          title={t("updateProfile.preferredLanguageError")}
          type="error"
          className="mb-2"
        />
        : null
      }
      <div className="card">
        <div className={isMobile ? "" : "p-4"}>
          {
            isEmailValidate ? <PersonalInfo /> : 
            <>
          {((userProfile?.associateType?.toLowerCase()?.includes("contractor") && !state?.userProfileBy) || state?.associateType?.toLowerCase()?.includes("contractor")) &&
            <div>
              <TabsNavigation selectedIndex={selectedIndex}>
                <Tab label={t("updateProfile.associateAndJobInfo")} onClick={() => setSelectedIndex(0)} />
                <Tab label={t("updateProfile.contractorInfo")} onClick={() => setSelectedIndex(1)} />
              </TabsNavigation>
              {selectedIndex === 0 && employeeProfile(isMobile, selectedButton, onClickButton, onPersonalInfoValidate, onShowErrorPage, setUserDetailResp, showPreferredLanguageError, setShowPreferredLanguageError, isEditable, setIsEditable, state, formValues, setFormValues, formChanged, setFormChanged, fieldsChangedRef, showInfoLoader, hideInfoLoader, isInfoLoading, setIsInfoLoading, securityOptions, setSecurityOptions, userDetails, countriesOptions, pronounsOptions, PGCSAccessOptions, preferredLanguageOptions, disableSave, setDisableSave, firstNameError, setFirstNameError, middleNameError, setMiddleNameError, lastNameError, setLastNameError, displayedFirstNameError, setDisplayedFirstNameError, displayedLastNameError, setDisplayedLastNameError, resetField, updateRespFormValuesAfterSuccess)}
              {selectedIndex === 1 && contractorProfile(isMobile, selectedButton, onClickButton, onPersonalInfoValidate, formValues, isEditable, setIsEditable, resetField, updateRespFormValuesAfterSuccess)}
              </div>
          }
          {((userProfile.associateType?.toLowerCase()?.includes("employee") && !state?.userProfileBy) || state?.associateType?.toLowerCase()?.includes("employee")) &&
            employeeProfile(isMobile, selectedButton, onClickButton, onPersonalInfoValidate, onShowErrorPage, setUserDetailResp, showPreferredLanguageError, setShowPreferredLanguageError, isEditable, setIsEditable, state, formValues, setFormValues, formChanged, setFormChanged, fieldsChangedRef, showInfoLoader, hideInfoLoader, isInfoLoading, setIsInfoLoading, securityOptions, setSecurityOptions, userDetails, countriesOptions, pronounsOptions, PGCSAccessOptions, preferredLanguageOptions, disableSave, setDisableSave, firstNameError, setFirstNameError, middleNameError, setMiddleNameError, lastNameError, setLastNameError, displayedFirstNameError, setDisplayedFirstNameError, displayedLastNameError, setDisplayedLastNameError, resetField, updateRespFormValuesAfterSuccess)
          }
          {((userProfile.associateType?.toLowerCase()?.includes("thirdparty") && !state?.userProfileBy) || state?.associateType?.toLowerCase()?.includes("thirdparty")) &&
            employeeProfile(isMobile, selectedButton, onClickButton, onPersonalInfoValidate, onShowErrorPage, setUserDetailResp, showPreferredLanguageError, setShowPreferredLanguageError, isEditable, setIsEditable, state, formValues, setFormValues, formChanged, setFormChanged, fieldsChangedRef, showInfoLoader, hideInfoLoader, isInfoLoading, setIsInfoLoading, securityOptions, setSecurityOptions, userDetails, countriesOptions, pronounsOptions, PGCSAccessOptions, preferredLanguageOptions, disableSave, setDisableSave, firstNameError, setFirstNameError, middleNameError, setMiddleNameError, lastNameError, setLastNameError, displayedFirstNameError, setDisplayedFirstNameError, displayedLastNameError, setDisplayedLastNameError, resetField, updateRespFormValuesAfterSuccess)
          }
           </>
          }
          
        </div>
      </div>
    </div>
     )}
    </>
  );
};

const employeeProfile = (isMobile, selectedButton, onClickButton, onPersonalInfoValidate, onShowErrorPage, setUserDetailResp, showPreferredLanguageError, setShowPreferredLanguageError, isEditable, setIsEditable, state, formValues, setFormValues, formChanged, setFormChanged, fieldsChangedRef, showInfoLoader, hideInfoLoader, isInfoLoading, setIsInfoLoading, securityOptions, setSecurityOptions, userDetails, countriesOptions, pronounsOptions, PGCSAccessOptions, preferredLanguageOptions, disableSave, setDisableSave, firstNameError, setFirstNameError, middleNameError, setMiddleNameError, lastNameError, setLastNameError, displayedFirstNameError, setDisplayedFirstNameError, displayedLastNameError, setDisplayedLastNameError, resetField, updateRespFormValuesAfterSuccess) => {

  return (
    <div className={isMobile ? " mobile-update-profile-container" : "main-container"}>

      {selectedButton === 0 && (
         <AssociateAndJobInfoEdit onPersonalInfoValidate={onPersonalInfoValidate} onShowErrorPage={onShowErrorPage} setUserDetailResp={setUserDetailResp} setShowPreferredLanguageError={setShowPreferredLanguageError} showPreferredLanguageError={showPreferredLanguageError} isEditable={isEditable} setIsEditable={setIsEditable} state={state} formValues={formValues} setFormValues={setFormValues} formChanged={formChanged} setFormChanged={setFormChanged} fieldsChangedRef={fieldsChangedRef} showInfoLoader={showInfoLoader} hideInfoLoader={hideInfoLoader} isInfoLoading={isInfoLoading} setIsInfoLoading={setIsInfoLoading} securityOptions={securityOptions} setSecurityOptions={setSecurityOptions} userDetails={userDetails} countriesOptions={countriesOptions} pronounsOptions={pronounsOptions} PGCSAccessOptions={PGCSAccessOptions} preferredLanguageOptions={preferredLanguageOptions} disableSave={disableSave} setDisableSave={setDisableSave} firstNameError={firstNameError} setFirstNameError={setFirstNameError} middleNameError={middleNameError} setMiddleNameError={setMiddleNameError} lastNameError={lastNameError} setLastNameError={setLastNameError} displayedFirstNameError={displayedFirstNameError} setDisplayedFirstNameError={setDisplayedFirstNameError} displayedLastNameError={displayedLastNameError} setDisplayedLastNameError={setDisplayedLastNameError} resetField={resetField} updateRespFormValuesAfterSuccess={updateRespFormValuesAfterSuccess} />
      )}
      {/* {selectedButton === 1 && (
        <PersonalInfo />
      )} */}

    </div>
  )
}

const contractorProfile = (isMobile, selectedButton, onClickButton, onPersonalInfoValidate, formValues, isEditable, setIsEditable, resetField, updateRespFormValuesAfterSuccess) => {
  return (
    <div className={isMobile ? " mobile-update-profile-container" : "main-container"}>

      <ContractorInformationEdit userDetailResp={formValues} isEditable={isEditable} setIsEditable={setIsEditable} resetField={resetField} updateRespFormValuesAfterSuccess={updateRespFormValuesAfterSuccess} />
    </div>
  )
}

// const InfoRow = ({ label, value }) => (
//   <div className="col-6 col-md-4 col-lg-3 mb-3">
//     <div className="profile-info">
//       <span className="profile-label">{label}</span>
//       <span className="profile-value">{value}</span>
//     </div>
//   </div>
// );


// const MobileProfileLayout = ({ selectedButton, setSelectedButton, onClickCancel, ShowAssociateAndJobInfoEdit, setShowAssociateAndJobInfoEdit }) => {


//   const onClickEditMode = () => {
//     setShowAssociateAndJobInfoEdit(true);
//   };

//   const onClickButton = (selectedBtn) => {
//     setSelectedButton(selectedBtn)
//     if (ShowAssociateAndJobInfoEdit) {
//       setShowAssociateAndJobInfoEdit(false);
//     }
//   }
//   return (
//     // <div className="main-container">
//     <div className="mobile-update-profile-container">
//       <div className="my-account-btn"><Icon
//         alt="alt value"
//         icon="arrow_back"
//         size="medium"
//         style={{ marginRight: '8px' }}
//       />My account</div>
//       <h4>
//         Update Profile
//       </h4>
//       <div class="mobile-btn-group">
//         <ButtonGroup
//           className={`custom-button-group selected-${selectedButton}`}
//           items={[
//             {
//               icon: 'person',
//               label: 'Associate & Job info',
//               onClick: () => onClickButton(0)
//             },
//             {
//               icon: 'smartphone',
//               label: 'Personal Info',
//               onClick: () => onClickButton(1)
//             }
//           ]}
//           menuPosition="bottom-right"
//           size="medium"
//           style={{ margin: "auto" }}
//         />
//       </div>
//       {!ShowAssociateAndJobInfoEdit ? (
//         <>
//           {selectedButton === 0 && (
//             <div className="mobile-profile-wrapper">
//               <div className="mobile-profile-container">
//                 <AccordionV2
//                   className=""
//                   presentation="border"
//                   separator
//                   style={{}}
//                 >
//                   <AccordionItemV2
//                     label="Associate Info"
//                     icon="person"
//                     presentation="box-shadow"
//                   >
//                     <Font textColorClass="$color-text-secondary">
//                       <div className="row">
//                         <InfoRow label="GPID" value="09455729" />
//                         <InfoRow label="First name" value="Details" />
//                         <InfoRow label="Pronouns" value="Details" />
//                         <InfoRow label="Middle initial" value="Details" />
//                         <InfoRow label="Last name" value="Details" />
//                         <InfoRow label="Displayed first name" value="Details" />
//                         <InfoRow label="Displayed last name" value="Details" />
//                         <InfoRow label="E-mail" value="Details" />
//                         <InfoRow label="Alternate Email" value="Details" />
//                         <InfoRow label="Country" value="Details" />
//                         <InfoRow label="Mobile" value="Details" />
//                       </div>
//                     </Font>
//                   </AccordionItemV2>
//                   <AccordionItemV2
//                     label="Job Info"
//                   icon="domain"
//                   >
//                     <Font textColorClass="$color-text-secondary">
//                       <div className="row">
//                         <InfoRow label="Associate type" value="Details" />
//                         <InfoRow label="Reporting manager" value="Details" />
//                         <InfoRow label="Job function" value="Details" />
//                         <InfoRow label="Division" value="Details" />
//                         <InfoRow label="Subdivision" value="Details" />
//                         <InfoRow label="Office phone" value="Details" />
//                         <InfoRow label="Extension" value="Details" />
//                       </div>
//                     </Font>
//                   </AccordionItemV2>
//                   <AccordionItemV2
//                     label="Language"
//                     icon="translate"
//                   >
//                     <Font textColorClass="$color-text-secondary">
//                       <div className="row">
//                         <InfoRow label="Preferred Language" value="Details" />
//                       </div>
//                     </Font>
//                   </AccordionItemV2>
//                 </AccordionV2>

//               </div>
//               <div className="mobile-edit-button-container">
//                 <button className="edit-button" onClick={onClickEditMode}>
//                   <Icon
//                     alt="alt value"
//                     icon="edit"
//                     size="large"
//                     style={{ marginRight: '4px' }}
//                   />
//                  <span style={{ fontSize: "16px" }}>Edit mode</span>
//                 </button>
//               </div>
//             </div>

//           )}

//           {selectedButton === 1 && (
//             <PersonalInfo />
//           )}
//         </>
//       ) : (
//         <AssociateAndJobInfoEdit onClickCancel={onClickCancel} />
//       )}
//     </div>
//     // </div>
//   );
// };

// const DesktopProfileLayout = ({ selectedButton, setSelectedButton, onClickCancel, ShowAssociateAndJobInfoEdit, setShowAssociateAndJobInfoEdit }) => {

//   // const [ShowAssociateAndJobInfoEdit, setShowAssociateAndJobInfoEdit] = useState(false);

//   const onClickEditMode = () => {

//     setShowAssociateAndJobInfoEdit(true);
//   };

//   const onClickButton = (selectedBtn) => {
//     setSelectedButton(selectedBtn)
//     if (ShowAssociateAndJobInfoEdit) {
//       setShowAssociateAndJobInfoEdit(false);
//     }
//   }

//   return (
//     <div className="main-container">
//       <div className="profile-header">
//         <h1 className="page-title ml-3 mb-10" style={{ fontSize: '18px', fontWeight: 'bold' }}>
//           Update Profile
//         </h1>
//         <ButtonGroup
//           className={`custom-button-group selected-${selectedButton}`}
//           items={[
//             {
//               icon: 'person',
//               label: 'Associate & Job info',
//               onClick: () => onClickButton(0)
//             },
//             {
//               icon: 'smartphone',
//               label: 'Personal Info',
//               onClick: () => onClickButton(1)
//             }
//           ]}
//           menuPosition="bottom-right"
//           size="medium"
//           style={{ marginLeft: "auto" }}
//         />
//       </div>
//       {!ShowAssociateAndJobInfoEdit ? (
//         <>

//           {/* <TabsNavigation selectedIndex={selectedTab}>
//               <Tab label="Associate & Job info" onClick={() => setSelectedTab(0)} />
//               <Tab label="Contractor Information" onClick={() => setSelectedTab(1)} />
//             </TabsNavigation> */}

//           {selectedButton === 0 && (
//             <div className="update-profile-container">
//               <div className="tab-content">
//                 <section className="section associate-info">
//                   <Icon
//                     alt="alt value"
//                     icon="person"
//                     size="large"
//                     style={{ marginBottom: '8px', color:"#3A3A3A" }}
//                   />
//                   <h3 style={{ color: '#0E647F' }}>Associate info</h3>
//                   <div className="row">
//                     <InfoRow label="GPID" value="09455729" />
//                     <InfoRow label="First name" value="Details" />
//                     <InfoRow label="Pronouns" value="Details" />
//                     <InfoRow label="Middle initial" value="Details" />
//                     <InfoRow label="Last name" value="Details" />
//                     <InfoRow label="Displayed first name" value="Details" />
//                     <InfoRow label="Displayed last name" value="Details" />
//                     <InfoRow label="E-mail" value="Details" />
//                     <InfoRow label="Alternate Email" value="Details" />
//                     <InfoRow label="Country" value="Details" />
//                     <InfoRow label="Mobile" value="Details" />
//                   </div>
//                 </section>
//                 <hr className="profile-divider" />

//                 <section className="section job-info">
//                   <Icon
//                     alt="alt value"
//                     icon="domain"
//                     size="large"
//                     style={{ marginBottom: '8px', color:"#3A3A3A" }}
//                   />
//                   <h3 style={{ color: '#0E647F' }}>Job info</h3>
//                   <div className="row">
//                     <InfoRow label="Associate type" value="Details" />
//                     <InfoRow label="Reporting manager" value="Details" />
//                     <InfoRow label="Job function" value="Details" />
//                     <InfoRow label="Division" value="Details" />
//                     <InfoRow label="Subdivision" value="Details" />
//                     <InfoRow label="Office phone" value="Details" />
//                     <InfoRow label="Extension" value="Details" />
//                   </div>
//                 </section>
//                 <hr className="profile-divider" />

//                 <section className="section language-info">
//                   <Icon
//                     alt="alt value"
//                     icon="translate"
//                     size="large"
//                     style={{ marginBottom: '8px', color:"#3A3A3A" }}
//                   />
//                   <h3 style={{ color: '#0E647F' }}>Language</h3>
//                   <div className="row">
//                     <InfoRow label="Preferred Language" value="Details" />
//                   </div>
//                 </section>


//                 <div className="edit-button-container">
//                   <button className="edit-button" onClick={onClickEditMode}>
//                     <Icon
//                       alt="alt value"
//                       icon="edit"
//                       size="large"
//                       style={{ marginRight: '8px' }}
//                     />
//                     Edit mode
//                   </button>
//                 </div>
//               </div>
//             </div>

//           )}

//           {selectedButton === 1 && (
//             <PersonalInfo />
//           )}
//         </>
//       ) : (
//         <AssociateAndJobInfoEdit onClickCancel={onClickCancel} />
//       )}
//     </div>
//   );
// };

export default UpdateProfile;
